const coalesceValues = (collection, name, value) =>
  typeof collection[name] === 'string'
    ? [collection[name], value]
    : [...collection[name], value];

export const getFormData = (form) =>
  Array.from($('input, select, textarea', form)).reduce((collection, input) => {
    const { tagName, type, name, checked, value } = input;
    if (!name) {
      return collection;
    }
    if (tagName === 'SELECT') {
      const selectedOption = $('option:selected', input);
      return { ...collection, [name]: selectedOption.val() };
    }
    else if (type === 'checkbox') {
      if (!checked) {
        return collection;
      }
      if (collection[name]) {
        return {
          ...collection,
          [name]: coalesceValues(collection, name, value)
        };
      }
      return { ...collection, [name]: value };
    }
    else if (type === 'radio') {
      if (!checked) {
        return collection;
      }
      return { ...collection, [name]: value };
    }
    if (collection[name]) {
      return { ...collection, [name]: coalesceValues(collection, name, value) };
    }
    return { ...collection, [name]: value };
  }, {});

export const trackFormData = (form, event = 'formSubmissionSuccess') => () => {
  window.dataLayer &&
    window.dataLayer.push({
      event,
      formId: form.getAttribute('name'),
      ...getFormData(form)
    });
};

export const sendFormData = (form, success, error, always, pre) => {
  if (pre) { // where this was usually the old GA event (trackFormData) for successful form submission
    pre();
  }

  var formData = getFormData(form);
  var headers = {};
  headers["__RequestVerificationToken"] = formData.__RequestVerificationToken;

  if(formData["g-recaptcha-response"] && formData["g-recaptcha-response"] instanceof Array)
  {
      var recaptchaResponses = "";  
      $.each(formData["g-recaptcha-response"], function(idx, value) {            
          recaptchaResponses = recaptchaResponses + value + "||";
      });

      headers["g-recaptcha-response"] = recaptchaResponses.substring(0, recaptchaResponses.length-2);
  }
  else {
      headers["g-recaptcha-response"] = formData["g-recaptcha-response"];
  }
   
// console.log("recaptcha", headers["g-recaptcha-response"]);
// console.log("sendFormData", getFormData(form));     
// console.log("sendFormData", form);

 
  return $.ajax({
    url: form.action || '/',
    type: form.method || 'POST',
    cache: false,
    headers: headers,
    data: JSON.stringify(formData),
    contentType: 'application/json; charset=utf-8',
    dataType: 'json'
  })
    .done(success)
    .fail(error)
    .always(always);
};
